import requestIdleCallback from 'ric-shim'

export const usePolyfills = () => {
    window.requestIdleCallback = requestIdleCallback
}